import { useAuth } from "../../../context/contextAuth.js";
import { useDesign } from "../../../context/contextDesign.js";
import { useProfile } from "../../../context/contextProfile.js";
import { useAwsUrl } from "../../../context/Dashboard/aws/contextUrl.js";
import { useEffect, useState } from "react";
import RiskExposureListPlaceholder from "../../../components/cards/data-card/RiskExposurePlaceholder.jsx";
import RiskExposureList from "../../../components/cards/data-card/2-RiskExpList-Cloud-Url.jsx";
import Vulnerabilities from "../../../components/cards/score-card/0-vulnerabilities.jsx";
import CriticalVul from "../../../components/cards/score-card/1-critical-vulnerability.jsx";
import SaveScore from "../../../components/cards/score-card/5-save-score.jsx";
import Solutions from "../../../components/cards/score-card/4-solutions.jsx";
import PieChartGraph from "./PieChart.jsx";
import EpssCard from "../../../components/cards/data-card/3-epss-card.jsx";

const ScanView = () => {
  const { user } = useAuth();
  const { bHeightVal, zoom } = useDesign();
  const { showEpssCard } = useProfile();
  const {
    webResults, currentIndex,
    TVulScore, CVulScore, saveScore,
    loadWebData,
    urlVulTable, urlEpssTable,
    resetState
  } = useAwsUrl();
  const props = { 
    bHeightVal, urlVulTable,
    assets: webResults, saveScore,
    cloud: 'aws', type: 'url'
  };
  const [preload, setPreload] = useState(true); 
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      setPreload(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) {
          await loadWebData(currentIndex);
        } else {
          resetState();
        }
      } catch (error) {
        console.error('Error in loadWebData:', error);
      }
    };
    fetchData();
  }, [currentIndex]);
  
  return (
    <div style={{ zoom: zoom }}>
      {showEpssCard && <EpssCard  epssTable={urlEpssTable} />}
      <div className="bg-success text-light rounded-3 p-1 ps-2 my-2 ms-2 me-2">
        <div>
          Scanned URL: <b>{webResults[currentIndex]?.url || ''}</b>
        </div>
      </div>
      <div className='d-flex justify-content-left'>
        {preload? <RiskExposureListPlaceholder /> : <RiskExposureList {...props} /> }
        <div style={{ height: bHeightVal }}>
          <div className='d-flex flex-row h-auto'>
            <div className='d-flex flex-column'>
              <Vulnerabilities score={TVulScore}/>
              <CriticalVul score={CVulScore}/>
            </div>
            <div className='d-flex flex-column'>
              <SaveScore setScore={saveScore}/>
              <Solutions data={urlVulTable}/>
            </div>
          </div>
          <PieChartGraph />
        </div> 
      </div>
    </div>
  );
};

export default ScanView;